// src/components/Accessibility/SkipLinks.tsx

export default function SkipLinks() {
  const skipLinks = [
    { href: '#main-content', label: 'Aller au contenu principal' },
    { href: '#navigation', label: 'Aller à la navigation' },
    { href: '#about', label: 'Aller à la section À propos' },
    { href: '#services', label: 'Aller aux services' },
    { href: '#testimonials', label: 'Aller aux témoignages' },
    { href: '#contact', label: 'Aller au contact' }
  ];

  return (
    <div className="skip-links" role="navigation" aria-label="Liens d'évitement">
      {skipLinks.map((link, index) => (
        <a
          key={index}
          href={link.href}
          className="skip-link"
          onClick={(e) => {
            e.preventDefault();
            const target = document.querySelector(link.href);
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              if (target instanceof HTMLElement) {
                target.focus();
              }
            }
          }}
        >
          {link.label}
        </a>
      ))}
    </div>
  );
}
